/* eslint-disable prettier/prettier */
import React from 'react'
import { Container } from '../styles/AbstractLayout'

const Abstract = () => (
  <Container>
    <div>
      <ul>
        <li>📃 Modelo de Certificação</li>
        <li>🕒 1065h carga horaria total</li>
        <li>✅ Suporte e Tutoria</li>
        <li>📜 25 Certificações</li>
        <li>📓 03 Qualificações Profissionais</li>
        <li>🎖️ 01 Certificado(s)</li>
        <li>☀️ Seguro Acadêmico</li>
        <li>📃 Certificado com Validade Nacional</li>
      </ul>
     </div>
    </Container>
)

export default Abstract